export const GET_NET_STATUS = 'GET_NET_STATUS';
export const SET_NET_STATUS = 'SET_NET_STATUS';
